import { Gender } from '../../shared/types/generated';

export const USER_GENDER_LIST = [
  { label: 'Masculino', value: Gender.Male },
  { label: 'Femenino', value: Gender.Female },
  { label: 'No declara', value: Gender.NoApply },
];
